// extracted by mini-css-extract-plugin
export default {"BoxEmptyDraftState":"_BoxEmptyDraftState--e4GRW","Icon":"_Icon--KBMHp","EmptySpace":"_EmptySpace--SH6v2"};